import {Component, OnInit, ViewChild,Input} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import {  Router } from '@angular/router';
import {GeneralService} from "../services/general.service";
import { DateService } from "../services/date.service";
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';


@Component({
  selector: 'app-liste-collaborateurs',
  templateUrl: './liste-collaborateurs.component.html',
  styleUrls: ['./liste-collaborateurs.component.scss']
})
export class ListeCollaborateursComponent implements OnInit {
  dataSource = [];
  columns = {TableRD : []}
  exist : boolean = false;
  displayedColumns= [];
  tbrecherche: any[];
  idRowSelected;
  param;
  collaborateurs;
  showTableColl : boolean = false;
  showButton : boolean = true;
  constructor(public router:Router,public route: ActivatedRoute,public generalService :GeneralService,public dateService : DateService) 
  {
    
  }
  //@ViewChild//
  @ViewChild("listeCollComponen",{static:false}) listeCollComponen : AvtListesComponent;
  ngOnInit() 
  {
    this.readParamUrl();
  }  
  exportToExcel()
  {
    this.generalService.exportToExcel(this.listeCollComponen, "LISTE" + this.collaborateurs.toUpperCase())
  }
  init()
  {
    this.getColumnCollaborateur();
    
  }
  choisirDocument()
  {
    if(this.listeCollComponen.row)
    {
      this.generalService.rowChoisie = this.listeCollComponen.row;
      this.generalService.dialogOpend.close();
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une seule ligne",false);
  }
  getColumnCollaborateur()
  {
    this.generalService.rechercheTable(this.generalService.urlColumnCollaborateur).subscribe(data =>       
    {   
      this.columns =  data;
      this.columns["read_Only"] = true;
      this.columns.TableRD[1].TableRD_Type = 101;
      this.getDataCollaborateur();
    });
  }
  
  getDataCollaborateur()
  {
    this.generalService.rechercheTable(this.generalService.urlListPerso+this.param).subscribe(data => 
    {   
      this.dataSource = data;
      var tabHref = []
      data.forEach(row => 
      {
        tabHref.push({popap : true, href:["/w/avt/collaborateur" + "/" + row.Perso_Matricule + "/3/" + this.param],row:row})
      });
      this.columns.TableRD[1]["tabHref"] = tabHref;
      this.showTableColl = true;
      setTimeout( () => 
      {
        this.listeCollComponen.setDataSource(this.dataSource);
        this.exist = true
        this.listeCollComponen.row = null;
      }, 10);
      
    });
  }

  planning()
  {
    if (this.listeCollComponen.row) 
    {
      this.router.navigate(['avt/planningcollaborateur',this.listeCollComponen.row.Perso_Matricule,this.dateService.setFormatDate( new Date()),1]);}
    else
    this.generalService.dialogSuccess("Veillez sélectionner une ligne",false)
    
  }
  afficher(typeTrs)
  {
    if (this.listeCollComponen.row) 
    {
      // this.router.navigate(['avt/collaborateur',this.listeCollComponen.rows[0].Perso_Matricule,typeTrs,this.param]);
      this.generalService.popupCenter("/w/avt/collaborateur" + "/" + this.listeCollComponen.row.Perso_Matricule + "/" + typeTrs + "/" + this.param)
    }
    else
    this.generalService.dialogSuccess("Veuillez sélectionner une seule ligne",false)
  }
  supprimer()
  {
    if (this.listeCollComponen.row) 
    {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result =>
      {
        if(result == "supprimer")
        {
          this.exist = false;
          var compt =  1; //this.listeCollComponen.rows.length;
          [this.listeCollComponen.row].forEach(collaborateur => 
          {
            var deleteFn = this.generalService.supprimerSanMsgConfirm(collaborateur.Perso_Matricule,"avtperso");
            if(deleteFn != null)
            {
              deleteFn.subscribe(data => 
              {
                compt--;
                if(compt == 0)
                {
                  this.getDataCollaborateur();
                  this.exist = true;
                }
                this.generalService.dialogSuccess("Elément supprimer",true);
                
              },
              error =>
              {
                compt--;
                this.generalService.dialogSuccess("Elément non supprimé",false);
                this.exist = true;
              });
            }
            });
          
        }
        if(result == "annuler")
        {
        }
      });

    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une ou plusieurs lignes",false)
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      // param = 0 collaborateur
      // param = 1 condidat
      // param = 2 apperant  
      this.param = params['param'];
      if(!this.generalService.isNotEmpty(this.param))
      {
        this.param = this.generalService.paramListeColl;
        this.showButton = false;
      }
      if(this.param=='1')
          this.collaborateurs = "CANDIDATS";
      else if(this.param=='0')
          this.collaborateurs = "COLLABORATEURS";
      else if(this.param=='2')
          this.collaborateurs = "APPRENANTS";
      this.init();
    });
  }
}



